module.exports = __webpack_public_path__ + "static/card1-1f8c012d08329ea78486511b45cb2269.png";